/**
 * Aviso da Agenda em qualquer tela do cockpit: convite novo, lembrete ("começa
 * em 15 min") e "começou" com o botão Entrar. Lembrete e "começou" ficam na
 * tela até a pessoa fechar ou entrar (como no Teams); convite e mudanças somem
 * sozinhos. Ao abrir o cockpit, reunião já em andamento também aparece.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Icone from './Icone';
import { ouvir, usar } from '../lib/chatEquipeStream';
import { entrarNaReuniao, emAndamento, quando, faltam } from '../lib/agendaEquipe';
import './AvisoAgenda.css';

const CHAVE_FECHADOS = 'agenda_avisos_fechados';
function fechados() { try { return new Set(JSON.parse(sessionStorage.getItem(CHAVE_FECHADOS) || '[]')); } catch (_) { return new Set(); } }
function marcarFechado(chave) { try { const s = fechados(); s.add(chave); sessionStorage.setItem(CHAVE_FECHADOS, JSON.stringify([...s].slice(-60))); } catch (_) { /* ok */ } }

function tocar() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    [0, 0.18].forEach((t, i) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.value = i ? 880 : 660; o.type = 'sine';
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.3);
      o.connect(g); g.connect(ctx.destination); o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.32);
    });
    setTimeout(() => ctx.close().catch(() => {}), 900);
  } catch (_) { /* sem som */ }
}

const TITULO = {
  convite: (d) => `${d.de || 'Alguém'} te convidou`,
  lembrete: (d) => `Começa ${faltam(d.reuniao.inicio)}`,
  comecou: () => 'A reunião começou',
  alterada: () => 'Reunião alterada',
  cancelada: () => 'Reunião cancelada',
  resposta: (d) => `${d.de} ${d.resposta === 'aceito' ? 'vai' : d.resposta === 'recusado' ? 'não vai' : 'talvez vá'}`,
};
const FIXOS = new Set(['lembrete', 'comecou']);

export default function AvisoAgenda() {
  const navigate = useNavigate();
  const [avisos, setAvisos] = useState([]);

  const fechar = useCallback((id) => { marcarFechado(id); setAvisos((a) => a.filter((x) => x.id !== id)); }, []);
  const mostrar = useCallback((acao, d) => {
    const r = d?.reuniao;
    if (!r) return;
    const id = `${r.id}-${acao}`;
    if (fechados().has(id)) return;
    setAvisos((a) => [...a.filter((x) => x.id !== id && !(x.r.id === r.id && FIXOS.has(acao))), { id, acao, r, titulo: (TITULO[acao] || (() => 'Agenda'))(d) }].slice(-3));
    if (!FIXOS.has(acao)) setTimeout(() => setAvisos((a) => a.filter((x) => x.id !== id)), 9000);
    if (acao === 'lembrete' || acao === 'comecou' || acao === 'convite') {
      tocar();
      if (document.visibilityState !== 'visible' && typeof window.Notification !== 'undefined' && window.Notification.permission === 'granted') {
        try {
          const n = new window.Notification(`${(TITULO[acao] || (() => ''))(d)}: ${r.titulo}`, { body: quando(r), tag: `agenda-${id}`, icon: '/logo192.png' });
          n.onclick = () => { window.focus(); navigate(`/escritorio/agenda?r=${r.id}`); n.close(); };
        } catch (_) { /* sem suporte */ }
      }
    }
  }, [navigate]);

  useEffect(() => {
    const soltar = usar();
    const off = ouvir('agenda', (d) => { if (d?.acao) mostrar(d.acao, d); });
    // Abriu o cockpit com reunião em andamento: avisa também.
    api.get('/equipe-agenda/proximas', { params: { limite: 3 } }).then(({ data }) => {
      for (const r of data?.reunioes || []) if (emAndamento(r) && r.minha_resposta !== 'recusado') mostrar('comecou', { reuniao: r });
    }).catch(() => { /* aviso é enfeite */ });
    return () => { off(); soltar(); };
  }, [mostrar]);

  if (!avisos.length) return null;
  return (
    <div className="agd-avisos" aria-live="polite">
      {avisos.map((a) => (
        <div key={a.id} className={`agd-aviso ${a.acao}`} role="status">
          <div className="agd-aviso-topo">
            <Icone nome={a.acao === 'cancelada' ? 'bloqueado' : a.acao === 'comecou' ? 'video' : 'calendario'} tamanho={18} />
            <div className="agd-aviso-texto">
              <b>{a.titulo}</b>
              <span>{a.r.titulo} · {quando(a.r)}</span>
            </div>
            <button type="button" className="agd-aviso-fechar" onClick={() => fechar(a.id)} aria-label="Fechar aviso"><Icone nome="fechar" tamanho={14} /></button>
          </div>
          <div className="agd-aviso-acoes">
            <button type="button" className="agd-btn" onClick={() => { fechar(a.id); navigate(`/escritorio/agenda?r=${a.r.id}`); }}>Ver</button>
            {(a.acao === 'lembrete' || a.acao === 'comecou') && (
              <button type="button" className="agd-btn primario" onClick={() => { fechar(a.id); entrarNaReuniao(navigate, a.r); }}><Icone nome="video" /> Entrar</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
